import React from 'react';

const CheckboxToggle = ({name, checked, onChange}) => (
	<label className="checkbox-toggle">
		<input type="checkbox" name={name} checked={checked} onChange={onChange}/>
		<div className="checkbox-toggle-btn"></div>
		{name}
	</label>
)

export default CheckboxToggle;
